import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import IntegrationVideoEmbed from '../../../components/IntegrationVideoEmbed';
import './styles/HowToModalContent.scss';

const HowToModalContent = ({ data = {}, onClose, setTitle }) => {
  const { platforms, defaultConfig } = data;
  const [selectedPlatform, setSelectedPlatform] = useState(null);

  const currentConfig = selectedPlatform
    ? platforms.find((p) => p.id === selectedPlatform)
    : defaultConfig;

  const handlePlatformClick = useCallback((platformId) => {
    setSelectedPlatform(platformId);
  }, []);

  useEffect(() => {
    if (currentConfig.title) {
      setTitle(currentConfig.title);
    }
  }, [currentConfig.title, setTitle]);

  return (
    <>
      <div className='welcome-modal__video-container'>
        <IntegrationVideoEmbed config={currentConfig} />
      </div>

      <div className='welcome-modal__platform-container'>
        <h3 className='welcome-modal__centered-header'>
          {selectedPlatform
            ? `How to embed on ${currentConfig.name}`
            : 'Where would you like to embed your store?'}
        </h3>

        <div className='welcome-modal__platforms-grid'>
          {platforms.map((platform) => {
            const isSelected = selectedPlatform === platform.id;
            const platformItemClass = `welcome-modal__platforms-item${
              isSelected ? ' welcome-modal__platforms-item--selected' : ''
            }`;

            return (
              <div
                key={platform.id}
                className={platformItemClass}
                onClick={() => handlePlatformClick(platform.id)}
              >
                <div
                  className='welcome-modal__platform-icon'
                  style={{ backgroundImage: `url(${platform.iconUrl || ''})` }}
                />
                <p>{platform.name}</p>
              </div>
            );
          })}
        </div>

        <p className='welcome-modal__skip-link' onClick={onClose}>
          {selectedPlatform
            ? 'Close and customize your store widget'
            : 'Skip and customize your store widget'}
        </p>
      </div>
    </>
  );
};

HowToModalContent.propTypes = {
  onClose: PropTypes.func.isRequired,
  setTitle: PropTypes.func.isRequired,
  data: PropTypes.shape({
    platforms: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        youtubeVideoId: PropTypes.string,
        iconUrl: PropTypes.string
      })
    ),
    defaultConfig: PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      videoSrc: PropTypes.string
    })
  })
};

export default HowToModalContent;
